<template>
  <section class="section">
    <div ref="content" class="content">
      <div ref="texts" class="texts">
        <h2>
          <trans t="SECTION_STABLE_TITLE"><br /></trans>
        </h2>
        <p>
          {{"SECTION_STABLE_DESC".t()}}
        </p>
      </div>

      <div ref="info" class="info">
        <div class="card">
          <img src="../assets/SectionStable_Stable.png" />
          <span>{{"SECTION_STABLE_STABLE".t()}}</span>
        </div>

        <div class="equal">
        </div>

        <div class="card">
          <img src="../assets/SectionStable_Dollar.png" />
          <span>{{"SECTION_STABLE_DOLLAR".t()}}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    let interSected = false;

    const observer = new IntersectionObserver(
    entries => 
    {
      entries.forEach(entry => {
        if (!interSected && entry.isIntersecting)
        {
          interSected = true;

           this.$anime({
            targets: this.$refs.texts.querySelectorAll("h2, p"),
            translateY: ["100%", 0],
            translateZ: 0,
            opacity: [0, 1],
            duration: 750,
            easing: "easeOutExpo",
            delay: (el, i) => 300 * i,
          });

          this.$anime({
            targets: this.$refs.info.querySelectorAll(".card, .equal"),
            scale: [0.7, 1],
            translateY: ["100%", 0],
            translateZ: 0,
            opacity: [0, 1],
            duration: 750,
            easing: "easeOutExpo",
            delay: (el, i) => 300 + 200 * i,
          });

          this.$anime({
            targets: this.$refs.info.querySelectorAll(".card img"),
            translateY: ["30%", "0%"],
            opacity: [0, 1],
            duration: 1000,
            easing: "easeOutExpo",
            delay: (el, i) => 400 + 400 * i,
          });

          this.$anime({
            targets: this.$refs.info.querySelectorAll(".card span"),
            translateY: ["30%", "0%"],
            opacity: [0, 1],
            duration: 1000,
            easing: "easeOutExpo",
            delay: (el, i) => 400 + 400 * i,
          });
        }
      });
    },
    {
      threshold: 0
    });
    observer.observe(this.$refs.content);
  }
}
</script>

<style scoped>
.section {
}

.content {
  position: relative;
  padding: 38rem 0 13.33rem 0;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  text-align: center;
}

.texts {
  margin-top: 2rem;

  & h2 {
    font-weight: 700;
    font-size: 4rem;
    line-height: 1.35;
    color: #000000;
  }

  & p {
    margin-top: 3.8rem;
    font-weight: 400;
    font-size: 2.6rem;
    line-height: 120%;
    color: #000000;
  }
}

.info {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 11.5rem;
}

.equal {
  margin: -0.33rem 7.2rem 0;
  width: 4rem;
  height: 3rem;
  background: transparent;
  border-top: solid 1rem #B8AA9F;
  border-bottom: solid 1rem #B8AA9F;
}

.card {
  display: flex;
  align-items: center;

  position: relative;
  width: 32.1rem;
  height: 11.7rem;
  background: #F7F7F7;
  border: 0.2rem solid #B8AA9F;
  box-shadow: 0.4rem 0.4rem 0 #B8AA9F;
  border-radius: 9.6rem;

  & img {
    margin-left: -0.66rem;
    margin-top: -2rem;
    width: 17rem;
  }

  & span {
    margin-left: auto;
    margin-right: 6rem;
    min-width: 10rem;
    font-weight: 600;
    font-size: 3.4rem;
    line-height: 120%;
    text-align: right;
    color: #000000;
  }

  &:last-child span {
    text-align: center;
    
  }
}

@media (max-width: 425px) {
  .content {
    padding: 6.5rem 0;
  }

  .texts {

    & h2 {
      font-size: 2rem;
    }

    & p {
      margin-top: 1.5rem;
      font-size: 1.4rem;
      line-height: 2.2rem;
      padding: 0 5rem;
    }
  }

  .info {
    margin-top: 4rem;
  }

  .card {
    width: 13.8rem;
    height: 5.8rem;

    background: #F7F7F7;
    border: 0.2rem solid #B8AA9F;
    box-shadow: 0.4rem 0.4rem 0 #B8AA9F;
    border-radius: 9.6rem;

    & img {
      margin-left: -0.66rem;
      margin-top: -1rem;
      width: 8rem;
    }

    & span {
      min-width: 36%;
      font-size: 1.8rem;
      white-space: nowrap;
    }
  }

  .equal {
    margin: 0 2rem;
    width: 2rem;
    height: 1.2rem;
    background: transparent;
    border-width: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionStable.vue